<script setup lang="ts">
// Chevron das navegações de elo (pódio, herói e carrossel).
//
// Existe porque antes as setas eram os caracteres `‹` e `›` centrados na mão
// com `pb-0.5 pr-0.5`: a métrica do glifo não bate com a da fonte do projeto,
// então o símbolo saía torto dentro do círculo — e cada lugar tinha um chute
// diferente de padding. Traço vetorial centra sozinho e sai igual nos três.
//
// Herda cor (`currentColor`) e tamanho (classe do pai) de quem usa.
defineProps<{ direction: 'prev' | 'next' }>();
</script>

<template>
  <svg
    aria-hidden="true"
    class="block"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2.4"
    viewBox="0 0 24 24"
  >
    <path :d="direction === 'prev' ? 'M15 5L8 12l7 7' : 'M9 5l7 7-7 7'" />
  </svg>
</template>
